<template>
  <Modal title="予約受付期限" @close="close">
    <div class="limit-select">
      <div>来店日</div>
      <div>
        <SelectBox :items="daysObj" class="light-colored" v-model.number="editDate" />
      </div>
      <div>の</div>
      <div>
        <SelectBox :items="hoursObj" class="light-colored" v-model.number="editTime" />
      </div>
      <div>時まで</div>
    </div>
    <template #footer-center>
      <Button @click="close">戻る</Button>
      <Button primary :disabled="!isChanged" @click="save">保存</Button>
    </template>
  </Modal>
</template>

<script>
import { isEqual } from 'lodash'
import Modal from '@/components/molecules/Modal'
import Button from '@/components/atoms/Button'
import SelectBox from '@/components/atoms/SelectBox'

export default {
  name: 'TimeLimitModal',
  components: {
    Modal,
    Button,
    SelectBox,
  },
  props: {
    /** 日付 */
    date: Number,
    /** 時間 */
    time: Number,
  },
  data() {
    return {
      editDate: !this.date && this.date !== 0 ? 3 : this.date,
      editTime: this.time || 17,
    }
  },
  computed: {
    daysObj() {
      const defDayArr = ['当日', '前日']
      const addDayArr = [...Array(89).keys()].map(i => i + 2 + '日前')
      return { ...[...defDayArr, ...addDayArr] }
    },
    hoursObj() {
      const hourArr = { ...[...Array(25).keys()] }
      delete hourArr[0]
      return hourArr
    },
    isChanged() {
      return this.editTime && !isEqual(`${this.editDate}${this.editTime}`, `${this.date}${this.time}`)
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      this.$emit('save', this.editDate, this.editTime)
    },
  },
}
</script>

<style lang="postcss" scoped>
.limit-select {
  align-items: center;
  display: flex;
  font-weight: bold;
  justify-content: center;

  > div {
    padding: 0 8px;
  }
}

.light-colored {
  >>> &::after {
    border-left: 5px solid #b7b7b7;
  }

  >>> select:disabled {
    color: var(--light-gray);
  }
}
</style>
